// Components
// Hooks
import { useAtomValue } from 'jotai';

import { DefaultAvatar as Avatar } from '@/components/base/Avatar';
// Atoms
import { socialProfileAtom } from '@/components/pages/giveaway-picker/Atoms/socialProfileAtom';
import { SummaryItemTitle } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/components/DrawSummary/components/SummaryItemTitle';

export default function SummaryItemFirstStep() {
    const selectedProfile = useAtomValue(socialProfileAtom);

    return (
        <div data-testid="summary-item-1">
            <SummaryItemTitle step={0} />
            {selectedProfile ? (
                <div className="flex items-center gap-3" data-testid="profile-displayed">
                    <Avatar url={selectedProfile?.avatar} fallback={selectedProfile?.slug[0]} />
                    <span className="text-sm">{selectedProfile?.slug}</span>
                </div>
            ) : null}
        </div>
    );
}
